import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#171717",
      "fill-rule": "evenodd",
      d: "M15 4.5v7a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 11.5v-7A1.5 1.5 0 0 1 2.5 3h11A1.5 1.5 0 0 1 15 4.5M6.47 8.237l.606.458a1.5 1.5 0 0 0 1.806.005l.635-.476 2.63 2.63a.5.5 0 0 0 .707-.707l-2.53-2.53 2.287-1.715a.5.5 0 0 0-.6-.8L8.282 7.9a.5.5 0 0 1-.602-.002L3.99 5.105a.5.5 0 0 0-.604.797l2.28 1.727-2.52 2.518a.5.5 0 0 0 .708.707z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }